import { render, staticRenderFns } from "./AssetsTypeForm.vue?vue&type=template&id=41987060"
import script from "./AssetsTypeForm.vue?vue&type=script&lang=js"
export * from "./AssetsTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports